import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "emailMask",
    standalone: false
})
export class EmailMaskPipe implements PipeTransform {
  transform(email: string) {
    var atTheRateIndex = email.lastIndexOf("@");
    var beforeAt = email
      .substring(0, atTheRateIndex)
      .split("")
      .map(function (o, i) {
        if (i < 2) {
          return o;
        } else {
          return "*";
        }
      })
      .join("");
    var afterAt = email.substring(atTheRateIndex + 1);
    var afterAtIndex = afterAt.indexOf(".");
    var domain = afterAt
      .substring(0, afterAtIndex)
      .split("")
      .map(function (o, i) {
        return o;
        // if (i < 3) {
        //   return o;
        // } else {
        //   return "*";
        // }
      })
      .join("");
    var afterDomain = afterAt.substring(afterAtIndex);
    return beforeAt + "@" + domain + afterDomain;
  }
}
